import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="mb-6">
          <Link to="/" className="text-blue-600 hover:text-blue-800 flex items-center mb-4">
            ← Zurück zum Formular
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Allgemeine Geschäftsbedingungen</h1>
          
          <div className="prose max-w-none text-gray-700 space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">Allgemeine Geschäftsbedingungen (AGB)</h2>
            <h3 className="text-lg font-semibold text-gray-900">der Nadine Rau u. Mike Trepte GbR</h3>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 1 Geltungsbereich</h3>
            <p>Diese AGB gelten für alle Verträge über die Erbringung von Online-Seminaren, Live-Programmen, Präsenzseminaren und Coaching-Dienstleistungen zwischen der Nadine Rau u. Mike Trepte GbR und den Teilnehmern.</p>
            <p>Das Widerrufsrecht gilt ausschließlich für Verbraucher im Sinne des § 13 BGB.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 2 Vertragsgegenstand</h3>
            <p>(1) Wir erbringen Dienstleistungen in den Bereichen:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Beratung und Implementierung von Software und KI-Tools</li>
              <li>Personaldiagnostik mit MapsTell, Innermetrix und 9Levels</li>
              <li>Coaching, Persönlichkeitsentwicklung und Führungskräfteentwicklung</li>
              <li>Online- und Live-Seminare sowie Präsenzveranstaltungen</li>
              <li>Tätigkeit als INQA-Coach (Initiative Neue Qualität der Arbeit)</li>
            </ul>
            <p>(2) Die Inhalte und Abläufe ergeben sich aus der jeweiligen Produktbeschreibung.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 3 Vertragsabschluss</h3>
            <p>(1) Bei Online-Buchungen über Stripe oder andere Buchungssysteme kommt der Vertrag mit Abschluss des elektronischen Zahlungsvorgangs zustande.</p>
            <p>(2) Mit der Buchung bestätigen Sie, diese AGB zur Kenntnis genommen zu haben.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 4 Preise und Zahlung</h3>
            <p>(1) Die Preise ergeben sich aus der jeweils gültigen Produktbeschreibung.</p>
            <p>(2) Zahlungen sind vor Beginn der Leistung fällig.</p>
            <p>(3) Preisänderungen wirken nur für zukünftige Buchungen.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 5 Teilnahmevoraussetzungen</h3>
            <p>(1) Die Teilnahme an Online-Programmen erfordert ein geeignetes Endgerät und eine stabile Internetverbindung.</p>
            <p>(2) Die Teilnehmer verpflichten sich zur aktiven Mitarbeit und zum vertraulichen Umgang mit allen Gruppeninhalten.</p>
            <p>(3) Die Verantwortung für persönliche Entscheidungen und Handlungen liegt bei den Teilnehmern selbst.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 6 Haftung</h3>
            <p>(1) Unsere Haftung ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.</p>
            <p>(2) Die Haftungsbeschränkung gilt nicht bei Verletzung von Leben, Körper oder Gesundheit.</p>
            <p>(3) Unsere Leistungen ersetzen keine medizinische oder psychotherapeutische Behandlung.</p>
            <p>(4) Bei der Implementierung von Software und KI-Tools übernehmen wir keine Haftung für die Funktionsfähigkeit der fremden Software oder die Korrektheit der KI-Ergebnisse. Wir unterstützen lediglich bei der Auswahl, Implementierung und Anwendung.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 7 Stornierung (freiwilliges Rücktrittsrecht)</h3>
            <p>Diese Regelung betrifft ausschließlich Stornierungen, nicht den gesetzlichen Widerruf.</p>
            <p>(1) Stornierungen sind schriftlich mitzuteilen.</p>
            <p>(2) Für Online-Programme:<br />
              – bis 14 Tage vor Beginn: vollständige Erstattung<br />
              – ab 13 Tagen vor Beginn: keine Erstattung
            </p>
            <p>(3) Für Präsenzseminare (sofern angeboten):<br />
              – bis 30 Tage vor Beginn: vollständige Erstattung<br />
              – 29–14 Tage: 50 % Erstattung<br />
              – 13–0 Tage: keine Erstattung<br />
              – Ersatzteilnehmer können kostenfrei gestellt werden.
            </p>
            <p>(4) Für Beratungsleistungen und Diagnostik-Tools:<br />
              – bis 7 Tage vor Termin: vollständige Erstattung<br />
              – ab 6 Tagen vor Termin: keine Erstattung<br />
              – Bei Nichterscheinen ohne Absage wird der volle Betrag fällig.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 8 Vertraulichkeit</h3>
            <p>Wir behandeln alle Informationen vertraulich. Dies gilt auch über das Vertragsende hinaus. Besonders gilt dies für im Rahmen der Personaldiagnostik erhobene persönliche Daten und Ergebnisse.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 9 Urheberrechte</h3>
            <p>Alle bereitgestellten Materialien, insbesondere Diagnostik-Instrumente und Schulungsmaterialien, sind urheberrechtlich geschützt und dürfen nicht ohne unsere Zustimmung vervielfältigt werden.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 10 Anwendbares Recht und Gerichtsstand</h3>
            <p>(1) Es gilt deutsches Recht.</p>
            <p>(2) Für Unternehmer ist der Gerichtsstand Kassel.</p>
            <p>(3) Für Verbraucher gilt der gesetzliche Gerichtsstand.</p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">§ 11 Salvatorische Klausel</h3>
            <p>Die Unwirksamkeit einzelner Bestimmungen berührt die Wirksamkeit der übrigen Regelungen nicht.</p>
            
            <p className="mt-8 text-sm text-gray-500">Stand: November 2025</p>
          </div>
          
          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
            >
              ← Zurück zur Hauptseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;